<template>
    <div class="site-footer ">
        <div class="row container">
            <div class="col col-s12">
        <img :src="$root.urlsite+'documenti/footerBM.png'" style="margin:0;"/>
        </div>
        </div>
<!--
        <div class="row container">
            <div class="col col-s6">
            FOOTER LEFT
            </div>

            <div class="col col-s6">
            FOOTER RIGHT
            </div>
        </div>
-->        
    </div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  }
}
</script>
<style>
.site-footer{
    background: #393a3a;
    height: 90px;
    color:#ffffff;
    line-height: 36px;
    font-size: 1.8rem;
    margin: 40px 0 0 0;
}
</style>




// WEBPACK FOOTER //
// Site-footer.vue?1e74db79